import { Action, Reducer } from "redux";
import { ModelIsValidAction, MODEL_IS_VALID, AppThunkAction, remoteActions } from ".";

import { TextInputState } from "./interfaces";
import { SET_ERROR } from "./actions";

export const CONTACTS_EMAIL_CHANGED = "CONTACTS_EMAIL_CHANGED";
export const CONTACTS_PHONE_CHANGED = "CONTACTS_PHONE_CHANGED";
export const ACTUAL_MILAGE_CHANGED = "ACTUAL_MILAGE_CHANGED";
export const GDPR_CHANGED = "GDPR_CHANGED";
export const GDPR_CHECK = "GDPR_CHECK";

export interface ProfileState {
  name: string;
  email: TextInputState;
  phone: TextInputState;
  secureSsn?: string;
  isValid: boolean;
  encryptedSSN?: string;
  encryptedName?: string;
  age?: number;
  gender?: string;
  campaignId?: string;
  isECustomer?: boolean;
  cxScriptEnabled?: boolean;
  portfolio?: string;
  encryptedRegistrationNumber?: string;
  isCarBatteryElectric?: boolean;
  isCarVolvoBatteryElectric?: boolean;
  isCarNew?: boolean;
  carModel?: string;
  carYear?: number;
  volvoCardNotOwner?: boolean;
  actualMilage?: TextInputState;
  gdpr?: GDPR;
  title?: string;
  errorTrigger?: boolean;
  carImageUrl?: string;
}

export interface GDPR {
  questionVisible?: boolean;
  selected: boolean;
  text?: string;
  requiredErrorMessage?: string;
  showError: boolean;
  readMore?: string;
  readMoreUrl?: string;
}

export const defaults = {
  name: "Test Tester",
  email: {
    title: "E-postadresse",
    state: 0,
    stateDescriptions: ["", "NotSet", "Incorrect"],
    secureValue: "",
    value: "",
  },
  phone: {
    title: "Mobilnummer",
    state: 0,
    stateDescriptions: ["", "NotSet", "Incorrect"],
    secureValue: "",
    value: "",
  },
  isValid: false,
  actualMilage: {
    title: "Hvor langt har bilen kjort?",
    state: 0,
    stateDescriptions: ["", "NotSet", "Incorrect"],
    bottomText: "Hvis du ikke vet hvor langt bilen har kjort, tar vi kontakt med deg etter kjopet for a fa registrert kilometerstand.",
  },
  gdpr: {
    questionVisible: true,
    selected: false,
    text: "Jeg godtar Ifs betingselser for kjop pa Internett, og samtykker til elektronisk kommunikasjon.",
    requiredErrorMessage: "required!",
    showError: false,
  },
  errorTrigger: false,
  carImageUrl: "",
};

type ChangeAction = {
  type: typeof CONTACTS_EMAIL_CHANGED | typeof CONTACTS_PHONE_CHANGED | typeof SET_ERROR;
  payload: { value: any };
};

type ValidAction = ChangeAction & ModelIsValidAction;

//const emailRegEx: RegExp = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-._]+\.[a-zA-Z]{2,4}$/;
const emailRegEx: RegExp = /^[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]{2,}(?:\.[a-z]{2,})+$/;
const phoneRegEx: RegExp = /^((\+|00)46)\d{9}$/;

const getInputState = (value: string, pattern: RegExp) => (value.length > 0 ? (pattern.test(value) ? 0 : 2) : 1);

const isValid = (state: ProfileState): ProfileState => {
  const emailState = getInputState(state.email.value ?? "", emailRegEx);
  const phoneState = getInputState(state.phone.value ?? "", phoneRegEx);
  const isValid = emailState === 0 && phoneState === 0;

  if (state.email.state === emailState && state.phone.state === phoneState && state.isValid === isValid) {
    return state;
  }

  return {
    ...state,
    email: {
      ...state.email,
      state: emailState,
    },
    phone: {
      ...state.phone,
      state: phoneState,
    },
    isValid: isValid,
  };
};

export const reducer: Reducer<ProfileState> = (state: ProfileState = defaults, input: Action | ModelIsValidAction): ProfileState => {
  const action: ChangeAction | ModelIsValidAction = input as ValidAction;

  switch (action?.type) {
    case CONTACTS_EMAIL_CHANGED: {
      const value = action.payload.value ?? "";
      if (state.email.value === value) {
        return state;
      }

      return {
        ...state,
        email: {
          ...state.email,
          value,
          secureValue: undefined,
          state: getInputState(value, emailRegEx),
        },
      };
    }
    case CONTACTS_PHONE_CHANGED: {
      const value = action.payload.value ?? "";
      if (state.phone.value === value) {
        return state;
      }
      return {
        ...state,
        phone: {
          ...state.phone,
          value,
          secureValue: undefined,
          state: getInputState(value, phoneRegEx),
        },
      };
    }
    case MODEL_IS_VALID: {
      return isValid(state);
    }
    case SET_ERROR: {
      return {
        ...state,
        errorTrigger: !state.errorTrigger,
      };
    }
    default:
      return state;
  }
};

export const actions = {
  customerEmailChanged:
    (value: unknown): AppThunkAction<ValidAction | {}> =>
      dispatch => {
        dispatch({
          type: CONTACTS_EMAIL_CHANGED,
          payload: { value: value as string },
        });
        const xx = getInputState(value as string, emailRegEx);
        if (xx === 0) {
          dispatch(remoteActions.requestEncryptedCustomerData());
        }
      },
  customerPhoneChanged:
    (value: unknown): AppThunkAction<ValidAction | {}> =>
      dispatch => {
        dispatch({
          type: CONTACTS_PHONE_CHANGED,
          payload: { value: value as string },
        });
        const xx = getInputState(value as string, phoneRegEx);
        if (xx === 0) {
          dispatch(remoteActions.requestEncryptedCustomerData());
        }
      },
};
